import React from "react";
import { RouterProvider, createBrowserRouter, Outlet } from "react-router-dom";

import Layout from "./pages/Layout";
import InstructionsPage from "./pages/Instructions";

import SignedMenu from "./components/TrelloMenu/Signed";
import ExportPage from "./pages/Export/ExportPage";
import BillingPage from "./pages/Billing";
import AuthPage from "./pages/Auth";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Layout>
        <Outlet />
      </Layout>
    ),
    children: [
      {
        path: "/",
        element: (
          <div className="p-5 text-center">
            <h3>Hello World.</h3>
          </div>
        ),
      },
      { path: "/instructions", element: <InstructionsPage /> },
      { path: "/billing", element: <BillingPage /> },
      { path: "/menu", element: <SignedMenu /> },
      { path: "/export", element: <ExportPage /> },
      { path: "/authorize", element: <AuthPage /> },
      {
        path: "*",
        element: (
          <div className="p-5 text-center">
            <h2>404</h2>
            <h3>Página desconhecida.</h3>
          </div>
        ),
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
